import Message from '@/Messages/Message';
import ComponentManager from '@/Management/ComponentManager';

export default class RefreshAssociationsMessage extends Message {

    public constructor(params: any) {
        super(params);
    }
}

ComponentManager.setMessage('RefreshAssociationsMessage', RefreshAssociationsMessage, 'RADPresentation.HTMLClient.DefaultViewExtensions');